import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import styled from "styled-components";
import { getSimpleEventSubEvent } from "./utilities/ApiCalls";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const SimpleEvent = () => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  const [simpleEventData, setSimpleEventData] = useState([]);
  const { id } = useParams();

  console.log(id);

  useEffect(() => {
    fetchSimpleEventSubEvent();
  }, []);

  const fetchSimpleEventSubEvent = async () => {
    try {
      // Fetch data from API
      const response = await getSimpleEventSubEvent(id);
      // Check if data exists
      if (response && response.status === "Success") {
        console.log("Simple Event Sub Events Response:", response.data);
        setSimpleEventData(response.data || []);
      } else {
        setSimpleEventData([]);
        console.error(
          "Error fetching simple event sub events:",
          response.message
        );
      }
    } catch (error) {
      setSimpleEventData([]);
      console.error("Error fetching simple event sub events:", error);
    }
  };

  // Null/empty check and fallback UI
  if (!Array.isArray(simpleEventData) || simpleEventData.length === 0) {
    return (
      <Layout>
        <div
          style={{
            color: "var(--color-text-tertiary)",
            textAlign: "center",
            padding: 40,
            background: "transparent",
          }}
        >
          No active events, tune in later.
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          backgroundColor: "transparent",
        }}
      >
        <Root>
          <div className="event-container">
            {/* <div className='info-box'>
                  <div className='info-content'>
                      <div className='number'>287+</div>
                      <div className='title-info'>Audience</div>
                  </div>
                  <div className='vr'></div>
                  <div className='info-content'>
                      <div className='number'>87+</div>
                      <div className='title-info'>Poems</div>
                  </div>
                  <div className='vr'></div>
                  <div className='info-content-small'>
                      <div className='number'>90+</div>
                      <div className='title-info '>Stories</div>
                  </div>
               </div>    */}

            <div className="events">
              {/* <h1 className='open-heading'>Open Mic Glimpse </h1> */}
              <h1 className="open-heading">Special Events</h1>
              <div className="gird-container">
                {simpleEventData &&
                  simpleEventData.length > 0 &&
                  simpleEventData.map((data) => (
                    <Link to={`/simple-sub-event/${data._id}`} className="cart">
                      <img
                        alt=""
                        src={
                          data.image ||
                          "https://images.unsplash.com/photo-1485579149621-3123dd979885?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                        }
                        className="img"
                      ></img>

                      <div className="title">{data.name}</div>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </Root>
      </div>
    </Layout>
  );
};

export default SimpleEvent;

const Root = styled.div`
  min-height: 800px;
  background-color: transparent;
  width: 100%;
  max-width: 1300px;
  height: auto;

  .number {
    font-weight: bold;
    font-family: "Georgia, serif";
    font-size: 20px;
    color: var(--color-text-tertiary);
  }
  .vr {
    width: 2px; /* Thickness of the line */
    height: 100%; /* Height of the line */
    background-color: var(--color-border); /* Color of the line */
    margin-right: 20px;
    border: 1px solid var(--color-border); /* Border around the line (optional) */
  }

  .gap {
    margin-top: 40px;
  }

  .slider {
    width: 90%;
  }

  .cart {
    max-height: 300px;
    max-width: 350px;
    display: flex;
    flex-direction: column;

    @media (min-width: 350px) and (max-width: 600px) {
      max-height: 175px;
      max-width: 200px;
    }
  }

  .img {
    height: 70%;
    width: 100%;
    border-radius: 20px;
  }

  .title {
    width: 95%;
    height: 30%;
    margin-top: 5px;
    font-size: 15px;
    color: var(--color-text-tertiary);
    text-align: start;
    margin-left: 5px;
    letter-spacing: -1px;
    line-height: 1; /* Adjusted line height to ensure proper spacing */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
    -webkit-line-clamp: 2; /* Truncate after 2 lines */
  }

  .gird-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding-left: 25px;
    padding-right: 25px;
    padding: 10px;

    /* For screens between 700px and 1199px, use 2 columns */
    @media (min-width: 350px) and (max-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 0px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .info-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--color-text-tertiary);
    flex-basis: 2/5;
    width: 100%;
  }

  .info-content-small {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--color-text-tertiary);
    flex-basis: 1/5;
    width: 100%;
  }

  .info-box {
    max-width: 500px;
    width: 60%;
    min-width: 300px;
    height: 100px;
    background-color: var(--color-surface);
    margin-bottom: 25px;
    display: flex;
    padding: 2px;
    padding-left: 25px;
    padding-right: 8px;
  }

  .img {
    border-radius: 10px;
    height: 250px;
    width: 100%;
  }

  .event-container {
    width: 100%;
    display: flex;
    margin-top: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .events {
    width: 100%;
    align-items: center;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
  }

  .event-title {
    text-align: center;
    width: 100%;
    color: var(--color-text-tertiary);
    font-size: 20px;
  }
  .event-heading {
    text-align: start;
    justify-content: start;
    width: 87%;
    align-items: start;
    color: var(--color-text-tertiary);
    font-size: 25px;
  }

  .open-heading {
    text-align: start;
    color: var(--color-text-tertiary);
    font-size: 25px;
    margin-left: 10px;
    @media (min-width: 350px) and (max-width: 600px) {
      padding-left: 18px;
      padding-bottom: 10px;
    }
  }
`;
